export const SEARCH_DOMAIN_TYPE_CODE = Object.freeze({
    // PATENT: 2401, // Patent
    'patent-utility-model': 'patent-utility-model', //: 12402,// Utility model
    'ic-topology': 'ic-topology', //: 12403, // IC Topology
    'oversea': 'oversea', //: 12404, // Oversea
    'all': 'all', //: 12402,// Utility model
})
export const CONST_SEARCH_DOMAIN_TYPE_CODE = Object.freeze(Object.keys(SEARCH_DOMAIN_TYPE_CODE))

// DOMAIN_APPLICATION_TYPE_CODE_MAPPER.put("patent-utility-model", Arrays.asList(new String [] {"8911", "8912", "8915"}));
// DOMAIN_APPLICATION_TYPE_CODE_MAPPER.put("ic", Arrays.asList(new String [] {"8913"}));
// DOMAIN_APPLICATION_TYPE_CODE_MAPPER.put("over-sea", Arrays.asList(new String [] {"8916"}));
// DOMAIN_APPLICATION_TYPE_CODE_MAPPER.put("all", Arrays.asList(new String [] {"8911", "8912", "8915", "8916"}));
// DOMAIN_APPLICATION_TYPE_CODE_MAPPER.put("temporary", Arrays.asList(new String [] {"8914"}))

export const SEARCH_DOMAIN_TYPE_CSS = Object.freeze({
    '8911': { color: 'red', domain: 'patent-utility-model'},
    '8912': { color: 'red', domain: 'patent-utility-model'},
    '8913': { color: 'blue', domain: 'over-sea'},
    '8915': { color: 'red', domain: 'patent-utility-model'},
})

export const SEARCH_FIELD_CODE = Object.freeze({
    'TI'              : 'TI'    ,          // 'Title',
    'PN'              : 'PN'    ,          // 'Patent number',
    'AN'              : 'AN'    ,          // 'application number',
    'NP'              : 'NP'    ,          // 'Priority number',
    'PCTAN'           : 'PCTAN' ,          // 'PCT Application number',
    'AD'              : 'AD'    ,          // 'Filing Date',
    'PA'              : 'PA'    ,          // 'Applicants Name',
    'IN'              : 'IN'    ,          // 'Inventor Name',
    'IC'              : 'IC'    ,          // 'IPC',

    'AADC'            : 'AADC'  ,          // 'Applicant Address Country',
    'AAD'             : 'AAD'   ,          // 'Applicant Address',
    'AR_AB'           : 'AR_AB' ,          // 'Arabic Abstract',
    'EN_AB'           : 'EN_AB' ,          // 'English Abstract',
    'ANA'             : 'ANA'   ,          // 'Applicant Nationality',
    'ARE'             : 'ARE'   ,          // 'Applicant Residence',
    'ALLTXT'          : 'ALLTXT',          // 'Text',
    'CL'              : 'CL'    ,          // 'Claims',
    'DE'              : 'DE'    ,          // 'Description',
    'DP'              : 'DP'    ,          // 'Publication Date',
    'FP'              : 'FP'    ,          // 'Front Page',
    'IADC'            : 'IADC'  ,          // 'Inventor Nationality',
    // 'INA'             : 'INA'   ,          // 'Inventor All Data',
    'PCN'             : 'PCN'   ,          // 'Priority Country',
    'PD'              : 'PD'    ,          // 'Priority Date',
    // 'PI'              : 'PI'    ,          // 'Priority All Data',
    // 'PAA'             : 'PAA'   ,          // 'Applicant All Data',
    'RAD'             : 'RAD'   ,          // 'Legal Representative Address',
    'RP'              : 'RP'    ,          // 'Legal Representative Name',
    // 'RPA'             : 'RPA'   ,          // 'Legal Representative All Data ',
    'WO'              : 'WO'    ,          // 'WIPO Publication Number',
    'ALLNUM'          : 'ALLNUM',          // 'All Numbers and IDs

    'AB'              : 'AB'    ,          // 'Arabic Abstract + English Abstract'
    'TOA'             : 'TOA'   ,          // 'Title or Abstract',
    'STATUS'          : 'STATUS',          // 'Selet status',
})
export const CONST_SEARCH_FIELD_CODE = Object.freeze(Object.keys(SEARCH_FIELD_CODE))

export const CONST_KEYWORD_SEARCH_FIELDS = Object.freeze([
    SEARCH_FIELD_CODE.TI,
    SEARCH_FIELD_CODE.PA,
    SEARCH_FIELD_CODE.IN,
    SEARCH_FIELD_CODE.RP,
    SEARCH_FIELD_CODE.AB,
])

export const CONST_ADVANCED_SEARCH_FIELDS = Object.freeze({
    'EXAMINER' : [
        // SEARCH_FIELD_CODE.AADC,
        SEARCH_FIELD_CODE.AAD,
        SEARCH_FIELD_CODE.AR_AB,
        SEARCH_FIELD_CODE.EN_AB,
        SEARCH_FIELD_CODE.ALLTXT,
        SEARCH_FIELD_CODE.CL,
        // SEARCH_FIELD_CODE.DE,
        // SEARCH_FIELD_CODE.DP,
        SEARCH_FIELD_CODE.FP,
        // SEARCH_FIELD_CODE.INA,
        // SEARCH_FIELD_CODE.PD,
        // SEARCH_FIELD_CODE.PI,
        // SEARCH_FIELD_CODE.PAA,
        SEARCH_FIELD_CODE.RAD,
        SEARCH_FIELD_CODE.RP,
        // SEARCH_FIELD_CODE.RPA,
        SEARCH_FIELD_CODE.WO,
        SEARCH_FIELD_CODE.ALLNUM,
    ],
    'PUBLIC': [
        // SEARCH_FIELD_CODE.AADC,
        SEARCH_FIELD_CODE.AAD,
        SEARCH_FIELD_CODE.AR_AB,
        SEARCH_FIELD_CODE.EN_AB,
        // SEARCH_FIELD_CODE.ALLTXT,
        // SEARCH_FIELD_CODE.CL,
        // SEARCH_FIELD_CODE.DE,
        // SEARCH_FIELD_CODE.DP,
        SEARCH_FIELD_CODE.FP,
        // SEARCH_FIELD_CODE.INA,
        // SEARCH_FIELD_CODE.PD,
        // SEARCH_FIELD_CODE.PI,
        // SEARCH_FIELD_CODE.PAA,
        SEARCH_FIELD_CODE.RAD,
        SEARCH_FIELD_CODE.RP,
        // SEARCH_FIELD_CODE.RPA,
        SEARCH_FIELD_CODE.WO,
        SEARCH_FIELD_CODE.ALLNUM,
    ]
    });

export const SEARCH_IC_SECTION_CODE = Object.freeze({
    'A': 'A',
    'B': 'B',
    'C': 'C',
    'D': 'D',
    'E': 'E',
    'F': 'F',
    'G': 'G',
    'H': 'H',
})
export const CONST_SEARCH_IC_SECTION_CODE = Object.freeze(Object.keys(SEARCH_IC_SECTION_CODE))

// AADC	Applicant Address Country
// AAD	Applicant Address
// AR_AB	Arabic Abstract
// EN_AB	English Abstract
// AD	Application Date
// AN	Application Number
// ANA	Applicant Nationality
// ARE	Applicant Residence
// -- ALL	All fields
// ALLTXT	Text
// CL	Claims
// CLASSIF	All Classifications
// CTR	Country
// DE	Description
// DP	Publication Date
// FP	Front Page
// PN	Patent Number
// IADC	Inventor Nationality
// IC	International Class
// IN	Inventor Name
// INA	Inventor All Data
// INF	Main Inventor Name
// NP	Priority Number
// PCN	Priority Country
// PD	Priority Date
// PI	Priority All Data
// PA	Applicant Name
// PAA	Applicant All Data
// PAF	Main Applicant Name
// PCTAN	Prior PCT Application Number
// RAD	Legal Representative Address
// RP	Legal Representative Name
// RPA	Legal Representative All Data 
// RPF	Main Legal Rep Name
// TI	Title
// WO	WIPO Publication Number
// ALLNUM 	All Numbers and IDs
